module.exports = __webpack_public_path__ + "../resources/img/ic-re-notification-setting-default.97b9d228.svg";